export default __webpack_public_path__ + "static/media/Search_chat.eac3a32f.svg";